import { render, staticRenderFns } from "./goods-merchandise.vue?vue&type=template&id=21347e84&scoped=true"
import script from "./goods-merchandise.vue?vue&type=script&lang=js"
export * from "./goods-merchandise.vue?vue&type=script&lang=js"
import style0 from "./goods-merchandise.vue?vue&type=style&index=0&id=21347e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21347e84",
  null
  
)

export default component.exports